"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
// This component is empty because its content is generated dynamically by the chart utils/plugins
var GraphTooltip = function () {
    return (react_1.default.createElement("div", { className: "ui-chart-tooltip" },
        react_1.default.createElement("div", { className: "ui-chart-tooltip-title" }),
        react_1.default.createElement("table", null,
            react_1.default.createElement("tbody", null))));
};
exports.default = GraphTooltip;
